---
title: "Half a year ago, I joined Bosch Business Innovations"
slug: "joined-bosch-business-innovations"
date: "2024-11-18"
excerpt: "Half a year ago, I joined Bosch Business Innovations with a clear goal: to challenge myself, learn new things, and ultimately apply my skills in new contexts. It’s been an incredible journey so far."
metaTitle: "Half a Year at Bosch Business Innovations | Kevin Rassner"
metaDescription: "Reflecting on six months at Bosch Business Innovations: Learning, experimentation, and growth. Insights on social density, joint language, and psychological safety."
language: "en"
author: "Kevin Rassner"
authorUrl: "https://rassner-dev.org"
linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7264212317947498496"
isLinkedInPost: true
tags: ["StartUpJourney", "GrowthMindset", "BusinessExperiments"]
---

Half a year ago, I joined Bosch Business Innovations with a clear goal: to challenge myself, learn new things, and ultimately apply my skills in new contexts. It’s been an incredible journey so far, filled with learning, experimentation, and growth. One part of this experience has been shaped by three books that perfectly reflect my journey:

📘 Testing Business Ideas – A guide to rapid experimentation.
📘 Crossing the Chasm – A roadmap for navigating innovation adoption.
📘 Ecosystemize Your Business – (Still reading, but already sparking ideas!)

Start-ups are often touted as the ideal environment to experiment in real-time. While that’s true, I’ve learned that having many opportunities doesn’t make the process easier - it makes it harder. The real challenge lies in deliberately ignoring the noise to focus on what matters most.

This challenge isn’t just individual - it’s organizational. At Grow, I’ve come to appreciate the importance of creating:

1️⃣ Social Density: Building trust to foster open communication and, eventually, seamless collaboration once the priorities are clear.
2️⃣ A Joint Language: Ensuring alignment and focus by defining shared terms and frameworks.
3️⃣ Psychological Safety: Empowering people to say 'no' to opportunities - not because they checked with their boss, but because they understand the strategy deeply and know it’s the right choice.

Reflecting on these past months, I’m reminded how crucial these elements are - not just for success in a start-up, but for any organization aiming to grow and innovate.

To anyone navigating a similar learning journey: What strategies have helped you stay focused and aligned amidst endless opportunities? Let’s exchange ideas!

